<template>
  <div class="o-iframe-widget">
    <iframe
      v-for="frame in frames"
      :key="frame.key"
      :src="frame.src"
      :class="{ 'is-active': frame.key === activeKey }"
      class="o-iframe-widget__frame"
      frameborder="0"
      allow="fullscreen"
      @load="onLoad(frame.key)"
    />
  </div>
</template>

<script>
export default {
  name: 'IframeWidget',
  props: {
    url: {
      type: String,
      required: true,
    },
    height: {
      type: String,
      default: '400px',
    },
    reloadInterval: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      frames: [{ key: 0, src: this.url }],
      activeKey: 0,
      nextKey: 1,
      timer: null,
    }
  },
  mounted() {
    if (this.reloadInterval > 0) {
      this.timer = setInterval(() => this.reload(), this.reloadInterval * 1000)
    }
  },
  beforeUnmount() {
    if (this.timer) clearInterval(this.timer)
  },
  methods: {
    onLoad(key) {
      if (key === this.activeKey) return
      setTimeout(() => {
        const oldKey = this.activeKey
        this.activeKey = key
        setTimeout(() => {
          this.frames = this.frames.filter((f) => f.key !== oldKey)
        }, 1000)
      }, 1000)
    },
    reload() {
      const key = this.nextKey++
      this.frames.push({ key, src: this.url })
    },
  },
}
</script>

<style lang="scss" scoped>
.o-iframe-widget {
  position: relative;
  width: 100%;
  height: v-bind(height);

  &__frame {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    pointer-events: none;

    &.is-active {
      opacity: 1;
      pointer-events: auto;
    }
  }
}
</style>
